module.exports = __webpack_public_path__ + "../resources/img/new_tooltip_2.43adf8e4.png";